import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

const StepCategory = () => {
  const { t } = useTranslation();
  return (
    <>
      <h2 className='mb-6 mb-md-8'>{t('onboarding_category_title')}</h2>
      <p className='mb-0'>
        <Trans i18nKey='onboarding_category_desc' />
      </p>
    </>
  );
};

export default StepCategory;
